module.exports = __webpack_public_path__ + "static/index/img/baikal-305.1e3f7a17.jpg";